<ng-template [ngIf]="navbar" [ngIfElse]="unavalibleNavbar">
  <button
    mat-icon-button
    *ngIf="isRootRoute || !canNavigationBack"
    snLayoutNavbarToggle
    [matTooltip]="navbar.opened ? ('map.appbar.closeNavbar' | t) : ('map.appbar.openNavbar' | t)"
    [attr.aria-label]="'map.appbar.navbar' | t"
  >
    <sn-icon fontSet="fal" fontIcon="fa-bars"></sn-icon>
  </button>

  <sn-icon-button *ngIf="!isRootRoute && canNavigationBack" snRouteBack [matTooltip]="'common.back' | t">
    <sn-icon fontSet="fal" fontIcon="fa-long-arrow-alt-left"></sn-icon>
  </sn-icon-button>
</ng-template>

<ng-template #unavalibleNavbar>
  <sn-icon-button
    [disabled]="!canNavigationBack"
    snRouteBack
    [matTooltip]="'common.back' | t"
    matTooltipPosition="after"
  >
    <sn-icon fontSet="fal" fontIcon="fa-long-arrow-alt-left"></sn-icon>
  </sn-icon-button>
</ng-template>
